import { DayView } from '@devexpress/dx-react-scheduler-material-ui';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => {
  return {
    normalCellOverride: {
      backgroundColor: theme.palette.common.accentLightblue,
    },
    shadedCellOverride: {
      backgroundColor: theme.palette.background.default,
    },
  };
});

const TimeTableCell = ({ ...props }: DayView.TimeTableCellProps) => {
  const classes = useStyles();
  const { isShaded } = props;
  return (
    <DayView.TimeTableCell
      {...props}
      className={
        isShaded ? classes.shadedCellOverride : classes.normalCellOverride
      }
    />
  );
};

export default TimeTableCell;
